import { render } from "./LoginPage.vue?vue&type=template&id=5f22d0bd&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=5f22d0bd&lang=css"
import "./LoginPage.vue?vue&type=style&index=1&id=5f22d0bd&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f22d0bd"]])

export default __exports__